module.exports = __webpack_public_path__ + "static/media/wizualizacja-26.cc01a5e2.png";